import { WpEtEnrollment } from './wp-et-enrollment.model';

export class WpActivity {
    constructor(
        public id?: number,
        public hoursPerWeek?: number,
        public activityCd?: string,
        public activityBeginDt?: any,
        public activityEndDt?: any,
        public mandResponsibilities?: string,
        public volnResposibilities?: string,
        public completionCd?: string,
        public completionReasonCd?: string,
        public shortTermGoal?: string,
        public longTermGoal?: string,
        public potentialBarrier?: any,
        public jobReadinessLevelCd?: string,
        public serviceNeeds?: string,
        public participantWill?: string,
        public agencyWill?: string,
        public providerName?: string,
        public activityVerificationCd?: string,
        public wpEtEnrollment?: WpEtEnrollment,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-activity.model.ts